

import { UntypedFormControl, Validators } from '@angular/forms';

import { catchError, tap } from 'rxjs/operators';

import {
	Observable,
	Subscriber,
	throwError,
} from 'rxjs';

import { CustomFormGroup as CustomFormGroupNew } from '@rs-bank/rs-forms-extention';
import {
	Column,
	Form,
	Section,
} from '@rs-bank/rs-layout';
import { ComponentBox } from '@rs-bank/rs-layout';


import {
	BiometricsRegistrationClientExistsException,
	BiometricsRegistrationDataRefinementException,
	MiddleValidationException,
	OperationConfirmationRequiredValidationException,
} from '../../../../common/exceptions/exceptions';
import { OperationConfirmation } from '../../../../shared/confirmation/core/models/operation-confirmation.model';
import { ConfirmationStepData } from '../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-confirmation.step';
import { WizardDataStep } from '../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-data-step';
import { CustomFormGroup } from '../../../../ui/custom-reactive-forms/custom-form-group';
import { RegistrationProductConfirmationCodeComponent } from '../../components/registration-product-confirmation-code/registration-product-confirmation-code.component';
import { BiometricsRegistrationWizardComponent } from '../biometrics-registration-wizard.component';
import { BiometricsRegistrationCreateRequest, BiometricsRegistrationCreateResponse } from '../biometrics-registration-wizard.service';


export class BiometricsRegistrationThirdStep extends WizardDataStep<BiometricsRegistrationWizardComponent, ConfirmationStepData> {

	public override form: CustomFormGroup = new CustomFormGroup({});
	public override newForm = new CustomFormGroupNew({
		confirmationCode: new UntypedFormControl(null, [
			Validators.required,
			Validators.maxLength(4),
			Validators.minLength(4),
		]),
	});
	private agreements: BiometricsRegistrationCreateRequest;
	private confirmation: OperationConfirmation;

	public onInit(data?: ConfirmationStepData): Observable<void> {
		this.wizard.options.goBackInvisible = false;

		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/typedef
		this.agreements = { agreements: (data?.newForm as unknown as CustomFormGroupNew<{ toggles: any }>).getCustomFormControl(c => c.toggles).value };
		this.confirmation = new OperationConfirmation(data?.operationConfirmationRequired?.operationId);
		return this.createInitialForm();
	}

	public onExecute(): Observable<unknown> {

		return this.wizardComponent.biometricsRegistrationWizardService.confirm(this.confirmation)
			.pipe(
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				catchError((error: any) => {

					switch (true) {
						case error instanceof OperationConfirmationRequiredValidationException:
							error = new MiddleValidationException(error.errors);
							break;
						case error instanceof BiometricsRegistrationClientExistsException:
						case error instanceof BiometricsRegistrationDataRefinementException:

							this.wizardComponent.biometricsRegistrationPopUpComponent.close();
							this.wizardComponent.biometricsRegistrationErrorPopUpComponent.exception = error;
							this.wizardComponent.biometricsRegistrationErrorPopUpComponent.showPopUp();

							break;
						default:
							break;
					}

					return throwError(error);
				}),
				tap(() => {
					this.wizardComponent.biometricsRegistrationPopUpComponent.close();
					this.wizardComponent.biometricsRegistrationSuccessPopUpComponent.showPopUp();
				}),
			);
	}

	private createInitialForm(): Observable<void> {
		return new Observable((subscriber: Subscriber<void>) => {

			this.stepInformation.setSubmitLabel('Подтвердить');
			this.stepInformation.isAvailableSubmitButton$$.next(true);


			this.layoutForm = new Form(
				undefined,
				new Column([

					new Section(
						'',
						new Column([
							new ComponentBox(
								RegistrationProductConfirmationCodeComponent, (componentInstance: RegistrationProductConfirmationCodeComponent) => {


									componentInstance.confirmationCode.pipe(
										tap((data: string) => {
											data = data?.trim();
											this.confirmation.otpValue = data;
											this.newForm.patchValue({ confirmationCode: data });
											this.wizardComponent.changeDetectorRef.detectChanges();
										}),
									)
										.subscribe();

									componentInstance.resetTimer
										.pipe(
											tap(() => {
												this.wizardComponent.biometricsRegistrationWizardService.create(this.agreements)
													.pipe(
														tap((data: BiometricsRegistrationCreateResponse) => {
															this.confirmation = new OperationConfirmation(data.otpId);
															componentInstance.confirmationCodeControl.setValue(null);
														}),
													)
													.subscribe();
											}),
										)
										.subscribe();
								}),
						]),
						{ cssClassList: ['biometrics-registration-params'] },
					),

				], {
					name: 'biometrics-registration-page',
					cssClassList: ['biometrics-registration-page'],
				}),
				undefined,
			);

			subscriber.next();
		});
	}

}
